import React from 'react';  
import { FaCloud, FaSeedling } from 'react-icons/fa';  
import styled, { keyframes } from 'styled-components';  
  
const Container = styled.div`  
  display: flex;  
  align-items: center;  
  justify-content: center;  
`;  
  
const IconContainer = styled.div`  
  display: flex;  
  align-items: center;  
  justify-content: center;  
  position: relative;  
  font-size: 5rem;  
  color: green;  
`;  
  
const Icon = styled.div`  
  margin: 0 20px;  
`;  
  
const moveData = keyframes`  
  0% { transform: translateX(0); opacity: 1; }  
  50% { opacity: 0; }  
  100% { transform: translateX(100px); opacity: 1; }  
`;  
  
const MovingData = styled.div`  
  position: absolute;  
  font-size: 2rem;  
  color: #FFD700;  
  animation: ${moveData} 2s infinite;  
  left: 50px;  
`;  
  
const DataTransferAnimation = () => {  
  return (  
    <Container>  
      <IconContainer>  
        <Icon>  
          <FaSeedling />  
        </Icon>  
        <MovingData>• • •</MovingData>  
        <Icon>  
          <FaCloud />  
        </Icon>  
      </IconContainer>  
    </Container>  
  );  
};  
  
export default DataTransferAnimation;  
